// Generated by CoffeeScript 1.11.1
(function() {
  var Header, Module,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Module = require('coffeescript-module').Module;

  module.exports = Header = (function(superClass) {
    var MODES;

    extend(Header, superClass);

    Header.aliasProperty('height', 'rows');

    Header.aliasProperty('width', 'cols');

    MODES = ['Bitmap', 'GrayScale', 'IndexedColor', 'RGBColor', 'CMYKColor', 'HSLColor', 'HSBColor', 'Multichannel', 'Duotone', 'LabColor', 'Gray16', 'RGB48', 'Lab48', 'CMYK64', 'DeepMultichannel', 'Duotone16'];

    Header.prototype.sig = null;

    Header.prototype.version = null;

    Header.prototype.channels = null;

    Header.prototype.rows = null;

    Header.prototype.cols = null;

    Header.prototype.depth = null;

    Header.prototype.mode = null;

    function Header(file) {
      this.file = file;
    }

    Header.prototype.parse = function() {
      var colorDataLen;
      this.sig = this.file.readString(4);
      if (this.sig !== '8BPS') {
        throw new Error('Invalid file signature detected. Got: ' + this.sig + '. Expected 8BPS.');
      }
      this.version = this.file.readUShort();
      this.file.seek(6, true);
      this.channels = this.file.readUShort();
      this.rows = this.height = this.file.readUInt();
      this.cols = this.width = this.file.readUInt();
      this.depth = this.file.readUShort();
      this.mode = this.file.readUShort();
      colorDataLen = this.file.readUInt();
      return this.file.seek(colorDataLen, true);
    };

    Header.prototype.modeName = function() {
      return MODES[this.mode];
    };

    Header.prototype["export"] = function() {
      var data, i, key, len, ref;
      data = {};
      ref = ['sig', 'version', 'channels', 'rows', 'cols', 'depth', 'mode'];
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        data[key] = this[key];
      }
      return data;
    };

    return Header;

  })(Module);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/header.js
// module id = 40
// module chunks = 0